import { FunctionComponent } from 'react';
import { StyledProps } from '.';

interface HStackProps extends StyledProps {}

const HStack: FunctionComponent<HStackProps> = ({
  children,
  style,
  className,
  id,
}) => {
  return (
    <div
      className={className}
      id={id}
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default HStack;
